export default __webpack_public_path__ + "static/media/cottage-cheesee.30127b50.png";